import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import Button from "@material-ui/core/Button";
import Wallet from "../../assets/images/CoinWallet.svg";
import wireless from "../../assets/images/wireless.svg";
import TextField from "@material-ui/core/TextField";
import English from "../../assets/images/English.png";
import Korea from "../../assets/images/korea.png";
import China from "../../assets/images/china.png";

import wallet from "../../assets/images/WalletB.svg";
import { withTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import Caption from "./caption";
import NewKeyPair from "./newKeyPair";
import { showMsg } from "../../actions/alertAction";
import * as sdk from "boa-sdk-ts";
import { WalletMA } from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { COIN_NET, TEST_NET, saveWalletData } from "../../utils/WalletUtils";
import { WalletResultCode, WalletUtils } from "boa-sdk-ts";
import { changeEndpoint } from "../../actions/networkAction";

const Register = (props) => {
  // These are all states of the component
  const dispatch = useDispatch();
  const { t } = props;
  const [openKeyModal, setOpenKeyModal] = useState(false);
  const [openModal, setOpenModal] = useState(true);
  const [openDiv, setOpenDiv] = useState(true);
  const [secretKey, setSecretKey] = useState("");
  const [secretKeyCopy, setSecretKeyCopy] = useState("");
  const [publicKeyCopy, setPublicKeyCopy] = useState("");
  const [Language, setLanguage] = useState(props.i18n.language);

  const [endPoint, setEndpoint] = useState(TEST_NET);
  const [walletName, setWalletName] = useState("");
  const [error, setError] = useState("");
  const { accounts } = WalletMA.instance();

  // Hook to set language to english by default
  useEffect(() => {
    props.i18n.changeLanguage("english");
    setLanguage("english");
    if (accounts.length > 0) {
      props.history.push("/overview");
    }
  }, []);

  // Method use to create new account
  const createAccount = async () => {
    let res = await WalletUtils.createKeyPair();
    if (res.code === WalletResultCode.Success) {
      setSecretKeyCopy(res.data.secret.toString(false));
      setPublicKeyCopy(res.data.address.toString());
      setOpenKeyModal(true);
    } else {
      dispatch(showMsg(res.message));
    }
  };

  // Method to show modal for public and private address
  const handleCloseKeysModal = () => {
    setOpenKeyModal(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const CreateWallet2 = async (e) => {
    setOpenDiv(!openDiv);
  };

  const addAccount = async () => {
    const key = secretKey.trim();
    let res;
    let isPublic = false;
    if (key[0] === "S") {
      res = sdk.WalletValidator.isValidSecretKey(secretKey);
    } else if (key[0] === "b") {
      res = sdk.WalletValidator.isValidPublicKey(secretKey);
      isPublic = true;
    } else {
      dispatch(showMsg(t("This_key_is_not_valid")));
      return;
    }

    if (ErrorCheckUtil.resCodeCheck(res)) {
      if (isPublic) {
        await accounts.add(
          walletName ? walletName : secretKey,
          new sdk.PublicKey(secretKey),
          true,
          true
        );
      } else {
        const sKey = new sdk.SecretKey(secretKey);
        await accounts.add(
          walletName
            ? walletName
            : sdk.KeyPair.fromSeed(sKey).address.toString(),
          sKey,
          true,
          true
        );
      }
      dispatch(changeEndpoint(endPoint));
      saveWalletData();
      accounts.checkBalance();
      props.history.push("/overview");
    }
  };

  // Method to set language
  const setLanguageLocal = (lang) => {
    setLanguage(lang);
    props.i18n.changeLanguage(lang);
  };

  return (
    <>
      <div className="welcome-box">
        <div className="welcomeContainer align-items-center">
          {/* Welcome Section without Login */}
          {openDiv ? (
            <div className="langDesc">
              <h1 className="welcomeTitle">
                {props.i18n.t("Welcome_to_BOSAGORA_Wallet")}
              </h1>
              <h3 className="welcomeSecText">
                {props.i18n.t("Secure_Easy_to_Use_Crypto_Wallet")}
              </h3>
              <img
                className="mx-auto d-block wallet-img"
                src={wallet}
                alt="wallet"
              />
            </div>
          ) : (
            //  Welcome section after going to create new wallet
            <div className="welcomeDesc">
              <h1 className="welcomeTitle">
                {props.i18n.t("Welcome_to_New_Wallet")}
              </h1>
              <h3 className="welcomeSecText">
                {props.i18n.t("Follow_these_steps_to_create_a_new_wallet")}
              </h3>
              <img
                className="mx-auto d-block depo-img"
                src={Wallet}
                alt="Wallet"
              />
            </div>
          )}
          {/* Language selection Section   */}
          {openDiv ? (
            <div className="languageBox">
              <div className="SelectLanguage">
                <div className="SelectLanguageBox cardBg">
                  <div className="EndpointBox">
                    <h1 className="EndTitle">
                      {props.i18n.t("Select_Language")}
                    </h1>
                    <div className="EndpointBtns">
                      <label
                        className="Langcontainer"
                        onClick={() => setLanguageLocal("english")}
                      >
                        <div className="box-in">
                          <img alt="English" src={English} />
                          <span
                            className={
                              Language === "english"
                                ? "checkmark checkmarkCircleActive"
                                : "checkmark"
                            }
                          />
                        </div>
                        <p>English</p>
                      </label>
                      <label
                        className="Langcontainer"
                        onClick={() => setLanguageLocal("korean")}
                      >
                        <div className="box-in">
                          <img alt="Korea" src={Korea} />
                          <span
                            className={
                              Language === "korean"
                                ? "checkmark checkmarkCircleActive"
                                : "checkmark"
                            }
                          />
                        </div>
                        <p>한국어</p>
                      </label>
                      <label
                        className="Langcontainer"
                        onClick={() => setLanguageLocal("chinese_simplified")}
                      >
                        <div className="box-in">
                          <img alt="China" src={China} />
                          <span
                            className={
                              Language === "chinese_simplified"
                                ? "checkmark checkmarkCircleActive"
                                : "checkmark"
                            }
                          />
                        </div>
                        <p>中文</p>
                      </label>
                    </div>
                  </div>
                  <div className="WalletName">
                    {/* Button to redirect create new wallet section  */}
                    <Button
                      className="CreateWalletBtn"
                      variant="contained"
                      color="primary"
                      onClick={(e) => CreateWallet2()}
                    >
                      {props.i18n.t("Create_Wallet")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="welcomeBox">
              {/* Create new wallet section */}
              <div className="SecretKey">
                <div className="SecretKeyForm cardBg">
                  <h1 className="SecretTitle">
                    {props.i18n.t("Secret_Seed_or_Public_Key")}
                  </h1>
                  <div className="SecretInputCont">
                    {/* Enter Secret Seed or Public Key */}
                    <TextField
                      autoComplete="off"
                      className="SecretInput"
                      id="filled-basic"
                      value={secretKey}
                      onChange={(e) => setSecretKey(e.target.value)}
                      label={props.i18n.t("Enter_seed_or_public_Mandotary")}
                      variant="filled"
                    />
                    {/* Button to open create new Secret Seed or Public Key modal */}
                    {secretKey.length > 0 ? (
                      ""
                    ) : (
                      <Button
                        className="CreateBtn"
                        variant="contained"
                        color="primary"
                        onClick={(e) => createAccount(e)}
                      >
                        {props.i18n.t("Create")}
                      </Button>
                    )}
                  </div>
                  <span className="validText">
                    <p style={{ color: "red" }}> {error}</p>
                  </span>
                  {/* Testnet or CoinNet  */}
                  <div className="EndpointBox">
                    <h1 className="EndTitle">{props.i18n.t("Endpoints")}</h1>
                    <div className="TestBtns">
                      <button
                        disabled
                        className={
                          endPoint === COIN_NET
                            ? "EndBtns active btn btn-default"
                            : " EndBtns btn btn-default"
                        }
                        onClick={() => setEndpoint(COIN_NET)}
                      >
                        <ReactSVG src={wireless} /> {props.i18n.t("CoinNet")}
                      </button>
                      <button
                        className={
                          endPoint === TEST_NET
                            ? "EndBtns active btn btn-default"
                            : " EndBtns btn btn-default"
                        }
                        onClick={() => setEndpoint(TEST_NET)}
                      >
                        <ReactSVG src={wireless} /> {props.i18n.t("TestNet")}
                      </button>
                    </div>
                  </div>
                  {/* Entera valid wallet name  */}
                  <div className="EndpointBoxName">
                    <TextField
                      autoComplete="off"
                      className="SecretInput"
                      id="filled-basic"
                      onChange={(e) => setWalletName(e.target.value)}
                      value={walletName}
                      label={props.i18n.t("Wallet_Name")}
                      variant="filled"
                    />
                  </div>
                  {/* Button to confirm create new wallet address */}
                  <button
                    className="btn btn-default NextBtn"
                    onClick={addAccount}
                  >
                    {props.i18n.t("Confirm")}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="SendModal">
        {/* Create new Secret Seed or Public Key modal */}
        <NewKeyPair
          openKeyModal={openKeyModal}
          handleCloseKeysModal={handleCloseKeysModal}
          secretKeyCopy={secretKeyCopy}
          publicKeyCopy={publicKeyCopy}
        />
        {/* Caption Information Component */}
        <Caption
          Language={Language}
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          setLanguageLocal={setLanguageLocal}
        />
      </div>
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Register))
);
